<template>
  <div class="d-flex justify-content-center w-100">
    <div class="row justify-content-center margin-top-10 w-100">
      <div v-for="item in legend" :key="item.target" :class="colClass" class="d-flex align-items-center justify-content-center legend-item text-center"  @click="scrollToSection(item.target)" >
        <SvgImage :src="item.icon" class="legend-icon" />
        <div class="legend-label f13-l16-l red">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgImage from "@/components/generic/SvgImage.vue";

export default {
  components: {
    SvgImage
  },
  props: {
    legend: {
      type: Array,
      required: true
    }
  },
  methods: {
    scrollToSection(target) {
      const element = document.getElementById(target);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      this.$emit('item-click', target);
    }
  },
  computed: {
    colClass() {
      const count = this.legend.length;
      return count === 3 ? "col-4" : count === 2 ? "col-6" : "col-12";
    }
  },
};
</script>

<style scoped>
.legend-item {
  cursor: pointer;
  min-width: 140px; /* Ensures even spacing */
  display: flex;
  justify-content: center;
}
.legend-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.legend-label {
  white-space: nowrap; /* Prevents text wrapping */
  text-align: left;
  margin-right: 8px;
}
</style>
